import { ArrayNotContainsObjectWithPropertyBaseValueConverter } from 'General/Resources/ValueConverters/ArrayNotContainsObjectWithPropertyBase';

export class ArrayNotContainsObjectWithPropertyValueConverter extends ArrayNotContainsObjectWithPropertyBaseValueConverter {

}